exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.backBtn[data-v-44d0cf4e] {\n  width: 40px;\n  margin: auto;\n}\n.mainDiv[data-v-44d0cf4e] {\n  text-align: center;\n  padding: 6px;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Registration/Privacy.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,aAAa;CACd;AACD;EACE,mBAAmB;EACnB,aAAa;CACd","file":"Privacy.vue","sourcesContent":["\n.backBtn[data-v-44d0cf4e] {\n  width: 40px;\n  margin: auto;\n}\n.mainDiv[data-v-44d0cf4e] {\n  text-align: center;\n  padding: 6px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44d0cf4e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Registration/Privacy.vue
// module id = 500
// module chunks = 19